import React from "react";
import styles from "../../../assets/css/modules/banners/banner.css";

export default ({ text }) => (
  <div className={styles.bannerWrapper}>
    <div className={styles.bannerText + " container"}>{text}</div>
  </div>
);
